import { Styles } from 'jss';
import * as cssVariable from 'cssVariables';

export const styles: Styles = {
  minimalButton: {
    background: 'none',
    border: 'none',
    color: cssVariable.white,
    padding: 0,
    width: 45,
    height: 40,
    '&:disabled': {
      opacity: 0,
      cursor: 'auto',
    },
  },
  icon: {
    width: 40,
    height: 40,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
};
